module.exports = __webpack_public_path__ + "fonts/ufonts.com_klavika-regular-opentype.6531bade.otf";